export enum UserAgentEnum {
    ANDROID = 'Android',
    IOS = 'iOS'
}
export enum DeeplinkEnum {
    LINK = 'https://pcc.tizy.fr',
    ANDROID_APP = 'io.tizy.pcc',
    IOS_APP = 'pcctizy://',
}